import * as React from 'react';
import { useEffect } from 'react';
import { Snackbar } from '@mui/material';
import { useToggleable } from '../../hooks';
import { useTranslation } from 'react-i18next';
import { APOLLO_ACCESS_DENIED_ERROR_EVENT } from '@shared/api/apollo';

const AccessDeniedError: React.FC = () => {
	const { t } = useTranslation('Checkout');
	const { isOpen, close, open } = useToggleable(false);

	useEffect(() => {
		const eventHandler = (event: any) => open();
		document.addEventListener(APOLLO_ACCESS_DENIED_ERROR_EVENT, eventHandler);

		return () => document.removeEventListener(APOLLO_ACCESS_DENIED_ERROR_EVENT, eventHandler);
	}, []);

	return (
		<Snackbar
			anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
			autoHideDuration={4000}
			open={isOpen}
			onClose={close}
			message={t('You are not logged in')}
		/>
	);
};

export default AccessDeniedError;
